import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appCustomTabs]'
})
export class CustomTabsDirective {

  private previousTabOffsetWidth: number;

  @Input() tabOffsetLeft: number;
  @Input() tabOffsetWidth: number;

  constructor(private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tabOffsetLeft && changes.tabOffsetWidth) {
      this.setLinePosition();
    }

    if (changes.tabOffsetWidth && !changes.tabOffsetWidth.firstChange) {
      this.setWidthLine(this.tabOffsetWidth);
    }

    if (changes.tabOffsetLeft && !changes.tabOffsetLeft.firstChange) {
      this.setLeftPositionLine(this.tabOffsetLeft);
    }
  }

  setLinePosition() {
    this.setLeftPositionLine(this.tabOffsetLeft);
    this.setWidthLine(this.tabOffsetWidth);
  }

  setWidthLine(tabOffsetWidth: number) {
    this.elementRef.nativeElement.style.width = `${tabOffsetWidth}px`;
  }

  setLeftPositionLine(tabOffsetLeft: number) {
    this.elementRef.nativeElement.style.left = `${tabOffsetLeft}px`;
  }

}
